import React, { useEffect, useState, useCallback } from 'react';
import { IconAlertCircleFilled, IconCircleCheckFilled, IconInfoCircleFilled } from '@tabler/icons-react';

interface NotifyProps {
  message: string;
  onDone: () => void;
}

const Notify: React.FC<NotifyProps> = ({ message, onDone }) => {
  const [visible, setVisible] = useState(false);

  const hide = useCallback(() => {
    setVisible(false);
    setTimeout(onDone, 300);
  }, [onDone]);

  useEffect(() => {
    if (message) {
      setVisible(true);
      const t = setTimeout(hide, 2500);
      return () => clearTimeout(t);
    }
  }, [message, hide]);

  if (!message) return null;

  const isError = message.toLowerCase().startsWith('ошибка');
  const isInfo = message === 'Фильтры сброшены';
  const icon = isError
    ? <IconAlertCircleFilled size={18} />
    : isInfo
      ? <IconInfoCircleFilled size={18} />
      : <IconCircleCheckFilled size={18} />;
  const toneClass = isError ? ' notif-error' : isInfo ? ' notif-info' : ' notif-success';

  return (
    <div className={`notif${visible ? ' show' : ''}${toneClass}`}>
      <span className="notif-icon" aria-hidden="true">{icon}</span>
      {message}
    </div>
  );
};

export { Notify };

/* ── Notify controller hook ── */
export function useNotify() {
  const [msg, setMsg] = useState('');

  const notify = useCallback((text: string) => {
    setMsg('');
    setTimeout(() => setMsg(text), 10);
  }, []);

  const clear = useCallback(() => setMsg(''), []);

  return { msg, notify, clear };
}
